import { createAsyncThunk } from "@reduxjs/toolkit";
import { installedBaseService } from "./InstalledBaseService";

export const fetchInstalledBaseData = createAsyncThunk(
  "installedBase/fetchData",
  async (params: {
    type: 'hardware' | 'software';
    sell_to_party: string;
    end_customer: string;
    network_ids: string[];
    limit?: number;
    offset?: number;
    filter?: string;
    order_by?: string;
  }) => {
    const {
      type,
      sell_to_party,
      end_customer,
      network_ids,
      limit = 100,
      offset = 0,
      filter = "",
      order_by = "",
    } = params;

    // Define properties based on type
    const properties =
      type === 'hardware'
        ? [
          "network_id",
          "network_status",
          "slice_id",
          "product_id",
          "product_description",
          "sold_qty",
          "installed_qty",
          "product_lifecycle_status",
          "product_family_id",
          "successor_replacement_product_id",
          "reconciliation_status",
        ]
        : [
            "network_id",
            "network_status",
            "network_name",
            "contract_id",
            "slice_id",
            "product_id",
            "product_name",
            "dc_license_name",
            "pd_dc_licence_name",
            "dc_application_name",
            "pd_application_name",
            "product_lifecycle",
            "license_expiry_commercial",
            "license_expiry_network",
            "status",
            "reconciliation_status",
            "reconciliation_mismatch_columns"
        ];

    // Convert type to API format
    const apiType = type === 'hardware' ? 'HW' : 'SUBS_APPS';

    const response = await installedBaseService.fetchInstalledBaseData({
      type: apiType,
      network_ids,
      properties,
      filter,
      sell_to_party,  // Passed as header
      end_customer,   // Passed as header
      limit,
      offset,
      order_by,
    });

    return {
      data: response.data || [],
      summary: response['summary'] || {
        total: 0,
        matched: 0,
        mismatch: 0,
        partially_matched: 0,
      },
    };
  }
);

export const fetchAssetDetails = createAsyncThunk(
  "installedBase/fetchAssetDetails",
  async (params: {
    product_id: string; // Can be empty now
    type: 'hardware' | 'software';
    sell_to_party: string;
    end_customer: string;
    network_ids?: string[];
    limit?: number;
    offset?: number;
    order_by?: string;
    filter?: string;
    category?: boolean; // New parameter to indicate if it's a category request
  }) => {
    const {
      product_id,
      type,
      sell_to_party,
      end_customer,
      network_ids = [],
      limit = 100,
      offset = 0,
      order_by = "",
      filter = "",
      category = false,
    } = params;

    const properties = [
      "network_id",
      "network_status",
      "network_name",
      "slice_id",
      "product_id",
      "product_description",
      "dc_hardware_installed_base_serial_number",
      "registered_product_details_serial_number",
      "product_lifecycle_status",
      "product_family_id",
      "successor_replacement_product_id",
    ];

    const apiType = type === 'hardware' ? 'HW' : 'SUBS_APPS';

    // Only add product filter if product_id is provided
    //const filter = product_id ? `product_id = '${product_id}'` : "";

    const response = await installedBaseService.fetchAssetDetails({
      type: apiType,
      network_ids,
      properties,
      filter, // Will be empty if no product_id
      sell_to_party,
      end_customer,
      limit,
      offset,
      order_by,
      category
    });

    return {
      data: response.data || [],
      totalCount: response['totalCount'] || 0,     // ← ADD THIS
      pageCount: response['pageCount'] || 0,       // ← ADD THIS
      product_id,
    };
  }
);